import { useTranslation } from 'react-i18next';
import { AiFillQuestionCircle } from 'react-icons/ai';

import { Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import type { TooltipProps } from '@mui/material/Tooltip';

type IconButtonTooltipProperties = {
  title: string;
  children?: TooltipProps['children'];
} & Omit<TooltipProps, 'title' | 'children'>;

export const IconButtonTooltip = ({
  title,
  disableInteractive = false,
  children = <AiFillQuestionCircle size="small" />,
  ...properties
}: IconButtonTooltipProperties) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Tooltip
      disableInteractive={disableInteractive}
      title={t(title)}
      {...properties}
      slotProps={{
        tooltip: {
          sx: {
            fontSize: '0.625rem',
            backgroundColor: 'transparent',
            marginTop: '-0.125rem !important',
            color: theme.palette.text.primary,
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};
